module.exports = __webpack_public_path__ + "img/51ne.28f65dd8.svg";